var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoBetViewSwitch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    viewBox: "0 0 48 48",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.7 20c0-.3-.2-.5-.5-.5H18.9c-.3 0-.5.2-.5.5v3c0 .3.2.5.5.5h10.3c.3 0 .5-.2.5-.5zm-1 2.5h-9.3v-2h9.3zm6.3.5c-.6 0-1 .4-1 1 0 2.7-1 5.2-2.9 7.1-3.9 3.9-10.2 3.9-14.1 0h.9c.6 0 1-.4 1-1s-.4-1-1-1h-3.7s-.1 0-.2.1h-.1v.1s0 .1-.1.2v3.7c0 .6.4 1 1 1s1-.4 1-1v-.9c4.7 4.6 12.3 4.6 16.9 0 2.3-2.3 3.5-5.3 3.5-8.5 0-.6-.4-1-1-1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14 24c0-2.7 1.1-5.2 2.9-7.1 3.9-3.9 10.2-3.9 14.1 0h-.9c-.6 0-1 .4-1 1s.4 1 1 1h3.7s.2-.1.3-.2c0 0 .1-.2.2-.3v-3.7c0-.6-.4-1-1-1s-1 .4-1 1v.9C27.6 11 20 11 15.4 15.6c-2.3 2.2-3.5 5.3-3.5 8.5 0 .6.4 1 1 1s1-.4 1-1Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11.3,
    height: 4,
    x: 18.3,
    y: 24.5,
    fill: "#fff",
    rx: 0.5,
    ry: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBetViewSwitch);
export default __webpack_public_path__ + "static/media/IcoBetViewSwitch.0a8dd3e86a665629014bd609cfab26e2.svg";
export { ForwardRef as ReactComponent };